export default __webpack_public_path__ + "static/media/placement.33f5a95b.png";